import React, { useState } from 'react';
import {
    List,
    Datagrid,
    TextField,
    BooleanField,
    DateField,
    EditButton,
    ShowButton,
    useDataProvider,
    useRefresh,
    useNotify,
} from 'react-admin';
import {
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
} from '@material-ui/core';
import { Delete as DeleteIcon } from '@material-ui/icons';

const CustomDeleteButton = ({ record }: any) => {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const dataProvider = useDataProvider();
    const refresh = useRefresh();
    const notify = useNotify();

    const handleClick = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleConfirm = async () => {
        setLoading(true);

        try {
            await dataProvider.delete('document-types', {
                id: record.id,
                previousData: record,
            });

            notify('Document type deleted successfully', {
                type: 'success',
            });
            refresh();
            setOpen(false);
        } catch (error) {
            notify(`Error: ${(error as any).message || 'Failed to delete'}`, {
                type: 'error',
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <IconButton
                onClick={handleClick}
                size="small"
                color="secondary"
                disabled={loading}
            >
                <DeleteIcon />
            </IconButton>

            <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
                <DialogTitle>Delete Document Type</DialogTitle>
                <DialogContent>
                    <Box mb={2}>
                        <Typography variant="body1" gutterBottom>
                            Are you sure you want to delete this document type?
                        </Typography>
                    </Box>
                    <Box
                        p={2}
                        bgcolor="grey.100"
                        borderRadius={1}
                        border="1px solid"
                        borderColor="grey.300"
                    >
                        <Typography variant="body2">
                            <strong>Name:</strong> {record.name}
                        </Typography>
                        <Typography variant="body2">
                            <strong>Code:</strong> {record.code}
                        </Typography>
                        {record.description && (
                            <Typography variant="body2">
                                <strong>Description:</strong>{' '}
                                {record.description}
                            </Typography>
                        )}
                    </Box>
                    <Box mt={2}>
                        <Typography variant="body2" color="error">
                            <strong>Warning:</strong> This action cannot be
                            undone.
                        </Typography>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleClose}
                        color="primary"
                        disabled={loading}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleConfirm}
                        color="secondary"
                        variant="contained"
                        disabled={loading}
                    >
                        {loading ? 'Deleting...' : 'Delete'}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

const DocumentTypeList = (props: any) => (
    <List {...props} sort={{ field: 'name', order: 'ASC' }}>
        <Datagrid>
            <TextField source="id" />
            <TextField source="name" />
            <TextField source="code" />
            <TextField source="description" />
            <BooleanField source="isActive" label="Active" />
            <DateField source="createdat" label="Created at" showTime />
            <ShowButton />
            <EditButton />
            <CustomDeleteButton />
        </Datagrid>
    </List>
);

export default DocumentTypeList;
